var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: normal;\n\n  div {\n    font-size: 28px;\n    line-height: 36px;\n    font-weight: bold;\n  }\n"], ["\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: normal;\n\n  div {\n    font-size: 28px;\n    line-height: 36px;\n    font-weight: bold;\n  }\n"])));
var CuppingScore = function (_a) {
    var cuppingScore = _a.cuppingScore;
    var t = useTranslation().t;
    if (!cuppingScore)
        return null;
    return (React.createElement(Wrapper, { className: "score" },
        t('params.cuppingScore.total'),
        React.createElement("div", null, cuppingScore.total)));
};
export default CuppingScore;
var templateObject_1;
